/* parameters = {key1:value1, key2:value2,...} */
async function httpGet (url, parameters) {
  const oUrl = new URL(url)
  console.log(parameters)
  Object.keys(parameters).forEach(key => oUrl.searchParams.append(key, parameters[key]))
  console.log(oUrl)
  const response = await fetch(oUrl, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      mode: 'no-cors'
    }
  })
  if (response.ok) {
    return response.json()
  } else if (response.status === 400) {
    const vm = await response.json()
    throw new Error(vm.data)
  }
}
async function httpPost (url, body) {
  var vm = null
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      mode: 'no-cors'
    },
    body: body
  })
  if (response.ok) {
    console.log(response)
    vm = await response.json()
  } else {
    const vm = await response.json()
    console.log(vm)
    throw response
  }
  return vm
}
async function httpPostForm (url, body) {
  var vm = null
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      Accept: 'text/html',
      'Content-Type': 'application/x-www-form-urlencoded',
      mode: 'no-cors'
    },
    body: body
  })
  if (response.ok) {
    vm = await response.json()
  } else if (response.status === 400) {
    const vm = await response.json()
    throw new Error(vm.data)
  }
  return vm
}
export { httpGet, httpPost, httpPostForm }
